import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { SiteCustomizationContext } from '../../src/logic/reactcontext/site-customization-context';

const tr = require('ts-translate-js').default.boundTR;
const accounting = require('accounting');

class Ticket extends Component {
    static contextType = SiteCustomizationContext;
    handleRemoveTicket(){
        this.props.onRemoveTicket(this.props.ticket.ProductID);
    }

    render(){
        const {siteSettings} = this.context;
        const remove = (this.props.onRemoveTicket && !this.props.readOnly )
                   ? <a href="#" onClick={() => this.handleRemoveTicket()}>{tr("cartcontent.remove")}</a>
                   : null;
        
                   let ticketName = this.props.ticket.SeatName;
        
                   const HasTicketDateOverride = this.props.ticket.TicketDateOverride !== null;
        if(HasTicketDateOverride){
            const TicketDateOverride = moment(this.props.ticket.TicketDateOverride).utcOffset(this.props.ticket.TicketDateOverride);
            ticketName += " (" + TicketDateOverride.format(tsapp.tr("program.format.moment.datetime")) + ")";
        }

        return (
            <div className="list-group-item">
                <div className="row">
                    <div className="col-xs-12 col-sm-5">
                        <span className="text-left text-bold">{" " + ticketName}</span> {remove}
                    </div>
                    <div className="col-xs-8 col-sm-5">
                        <span className="text-right "><em>{" " + this.props.ticket.PriceName}</em></span>
                    </div>
                    {!this.props.showOnlyWholePricesOnInternet ?
                     <div className="col-xs-4 col-sm-2 text-primary text-right text-bold">
                         <span className="price accented-text nowrap pull-right">{accounting.formatMoney(siteSettings.taxesOnlyAtCheckout ? this.props.ticket.TotalBeforeTaxes : this.props.ticket.Total)}</span>
                     </div>
                     : null}
                </div>
            </div>
        );
    }
}

Ticket.propTypes = {
    ticket: PropTypes.object,
    onRemoveTicket: PropTypes.func,
    showOnlyWholePricesOnInternet: PropTypes.bool,
    readOnly: PropTypes.bool
};

export default Ticket;
